import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-800/80 bg-primary-950">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
                <i className="ri-moon-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-50">
                午夜视频
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-400">
              午夜视频是一个专注深夜观影的影视内容平台，收录高清午夜电影与精选短视频，用清晰的分类和编辑推荐，帮你把深夜的时间花在值得的片子上。
            </p>
            <p className="mt-4 flex items-start gap-2 text-xs leading-6 text-foreground-500">
              <i className="ri-information-line mt-0.5 text-sm text-accent-500" />
              本站暂未接入在线播放功能，所有页面内容均为封面与信息展示，用于内容浏览与发现。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">内容导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-400 transition-colors hover:text-accent-400">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/movies" className="text-foreground-400 transition-colors hover:text-accent-400">
                  午夜电影分类
                </Link>
              </li>
              <li>
                <Link to="/short-videos" className="text-foreground-400 transition-colors hover:text-accent-400">
                  精彩短视频
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-400 transition-colors hover:text-accent-400">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">关于与帮助</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-foreground-400 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-foreground-400 transition-colors hover:text-accent-400">
                  联系与反馈
                </Link>
              </li>
              <li>
                <Link to="/about#notice" className="text-foreground-400 transition-colors hover:text-accent-400">
                  使用须知
                </Link>
              </li>
              <li>
                <Link to="/about#copyright" className="text-foreground-400 transition-colors hover:text-accent-400">
                  版权声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 午夜视频 Midnight Video. 本站演示内容均为虚构，仅供产品展示使用。</p>
          <p className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-moon-line text-sm text-secondary-400" />
              深夜不打烊
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-sm text-secondary-400" />
              内容分级提示
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}